import UsersModule from '@features/Users/Users.Module';

const Users = () => {
  return <UsersModule />;
};

export default Users;
